export default __webpack_public_path__ + "locales/vi/VersionHistory.json?hash=65d6e89d4f47670a824fd164168aeb2d";